/* OBJECTS */
import $ from 'jquery';
window.jQuery = $;
import Swiper from 'swiper';
import moment from 'moment';
import clndr from 'clndr';
require("@fancyapps/fancybox");
require( "../../addon_modules/pickadate/lib/picker.js");
require( "../../addon_modules/pickadate/lib/picker.time.js");
require( "../../addon_modules/pickadate/lib/picker.date.js");
require( "../../addon_modules/pickadate/lib/translations/lt_LT.js");
require( "../../node_modules/tooltipster/dist/js/tooltipster.bundle.min.js");
export default class App {
  constructor() {}
  formPoster = () => {
    $('body').on('click','#invoice_for_company', function(e) {
      $('.invoice-form').toggleClass('hidden');
    });

    $('body').on('click','.post-it', function(e) {
      e.preventDefault();
      $(this).parents('form').submit();
    });

    $('body').on('focus','input.error,select.error', function(e) {
      e.preventDefault();
      $(this).removeClass('error');
      $(this).parent().removeClass('error');
    });

    $('body').on('click','.add-more', function(e) {
      e.preventDefault();
      var parent = $(this).parent();
      var input = parent.find('input:first').clone().val('');
      input.insertBefore( $(this) );
    });

    $('body').on('click','.duplicate-more', function(e) {
      e.preventDefault();
      var parent = $(this).parent();
      var inputsWrap = $(this).parents('.inputs');
      var clone = parent.clone();
      parent.find('.duplicate-more').remove();
      clone.find('input').val('N / a');
      clone.find('textarea').val('N / a');
      clone.appendTo(inputsWrap);
      $('.button.post-it').trigger('click');
    });

    $('body').on('click','.duplicate-more-no-post', function(e) {
      e.preventDefault();
      var parent = $(this).parent();
      var inputsWrap = $(this).parents('.inputs');
      var clone = parent.clone();
      parent.find('.duplicate-more-no-post').remove();
      clone.find('input,textarea,select').val('');
      clone.appendTo(inputsWrap);
    });

    $('body').on('click','.duplicate-timetable', function(e) {
      e.preventDefault();
      var week = $(this).data('weekday');
      var number = $(this).parents('.inputs').data('numbers');
      var new_number = number+1;
      $(this).parents('.inputs').data('numbers',new_number);
      var parent = $(this).parent();
      var inputsWrap = $(this).parents('.inputs');
      $('.duplicate-timetable').hide();
      var clone = $('.clone-this').clone();
      clone.find('.duplicate-timetable').show();
      clone.find('input,textarea,select').val(null);
      clone.find('.time-used').remove();
      clone.find('.name-of-day').html('Naujas įrašas');

      var html = clone.html();
      const regEx = new RegExp('conf-1', "g");
      html = html.replace(regEx, "conf-"+new_number);

      const regEx2 = new RegExp('day-1', "g");
      html = html.replace(regEx2, "day-"+week+"");

      inputsWrap.append( '<div class="input-group">'+html+'</div>' );
    });

    $('body').on('change','.auto-post-on-select', function(e) {
      $(this).parents('form').submit();
    });
  }
  egzamFilter = () => {
    $('body').on('click', '.filter-nav>a', function(e){
      e.preventDefault();
      var chosen_filter = $(this).attr('href');
      $('.cp-tabs>.tab').hide();
      $(chosen_filter).show();
    });
    $('.buttons-line.filter-nav .always-active').trigger('click');
    /*
    $('body').on('click', '.filter-nav>a', function(e){
      e.preventDefault();
      var tabs = $('.cp-tabs>.tab');
      var chosen_filter = $(this).attr('href');

      switch (chosen_filter) {
        case '#all':
          tabs.show();
          $('.btn-pay').show();
          $('.btn-attach-pay').show();
          $('.btn-attach-money-back').show();
          $('.btn-cancel').show();
        break;
        case '#paid':
          tabs.hide();
          $('.cp-tabs>.tab[data-filter-paid=1]').show();
          $('.btn-pay').hide();
          $('.btn-attach-pay').hide();
          $('.btn-attach-money-back').hide();
          $('.btn-cancel').show();
        break;
        case '#unpaid':
          tabs.hide();
          $('.cp-tabs>.tab[data-filter-paid=0]').show();
          $('.btn-pay').show();
          $('.btn-attach-pay').hide();
          $('.btn-attach-money-back').hide();
          $('.btn-cancel').show();
        break;
        case '#attachinvoice':
          tabs.hide();
          $('.cp-tabs>.tab[data-filter-invoice=0]').show();
          $('.btn-pay').hide();
          $('.btn-attach-pay').show();
          $('.btn-attach-money-back').hide();
          $('.btn-cancel').hide();
        break;
        case '#results':
          tabs.hide();
          $('.cp-tabs>.tab[data-filter-passed]').show();
          $('.btn-pay').hide();
          $('.btn-attach-pay').hide();
          $('.btn-attach-money-back').hide();
          $('.btn-cancel').hide();
        break;
        case '#canceled':
          tabs.hide();
          $('.cp-tabs>.tab[data-filter-canceled]').show();
          $('.btn-pay').hide();
          $('.btn-attach-pay').hide();
          $('.btn-attach-money-back').show();
          $('.btn-cancel').hide();
        break;
      }
    });
    $('.buttons-line.filter-nav .always-active').trigger('click');
    */
  }
  swiperInit = () => {
    var title_slider = new Swiper('.slider', {
      loop: true,
      pagination: {
       el: '.swiper-pagination',
       clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    var carousel_slider = new Swiper('.column-swiper', {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 30,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 30
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        1078: {
          slidesPerView: 4,
          spaceBetween: 30
        }
      }
    });
  }
  calendar_list = (list, price, title_string, price_string, close_string, confirm_string, isadmin) => {
    var date = list[0]['date'];
    price_string = price_string.replace("%s", price);
    var template = `
    <h2><span class="calendar"><i class="far fa-calendar-alt"></i> `+date+`</span> <span class="egzam-title">`+title_string+`</span> <span class="price">`+price_string+`</span></h2>
    <ul>
  `;
  for(const element of list) {
      template = template +`<li><div class="envl"><input type="radio" name='time' value="`+date+'|'+element.time+`"/><span class="label">`+element.timelabel+`</span></div></li>`;
  }
  /*if(isadmin=='yes'){
    template = template +`<li><div class="envl"><input type="radio" name='time' value="`+date+`|notime"/><span class="label">Be laiko</span></div></li>`;
  }*/
  template = template +`
    </ul>
    <div class="close-btn-wrap tac"><a href="" rel='nofollow' class="button confirm post-it btn-green">`+confirm_string+`</a><a href="" class="button close btn-red">`+close_string+`</a></div>
    `;


    $('#calendar_list').html(template);
    $('#calendar_list').addClass('open');
  }
  regulartabs = () => {
    $('.nav-tabs').each( function( index, element ){
      var main = $(this);
      main.find('.filter-data>*').hide();
      main.find('.filter-nav-mesh>a').on('click', function(e) {
        e.preventDefault();
        var anchror = $(this).attr('href');
        main.find('.filter-data>*').hide();
        $(anchror).show();
      });
    });
  }
  tableFilter = () => {
    var filters = {};
    function sort(grid){
      grid.find('[data-group]').removeClass('hide');
      grid.find('[data-group]').removeClass('shown');
      for (var key in filters) {
        var value = filters[key];
        if(value.length>0) {
          var entry = grid.find('[data-type="'+key+'"]');
          entry.each( function( index, element ){
            var entry_value = $(this).html().toLowerCase();
            var found = entry_value.indexOf(value.toLowerCase());
            var group = $(this).data('group');
            if(found>0) {
              grid.find('[data-group="'+group+'"]').addClass('shown');
            }else{
              grid.find('[data-group="'+group+'"]').removeClass('shown');
              grid.find('[data-group="'+group+'"]').addClass('hide');
            }
          });
        }
      }
    }
    $('input[data-filter]').each(function(index, value) {
      var input = $(this);
      input.on('change', function(e){
        $(this).parents('.filtered-grid').find('[data-group]').removeClass('filtered');
        var value = $(this).val();
        var type = $(this).data('filter');
        filters[type] = value;
        sort($(this).parents('.filtered-grid'));
        //$('[data-group="'+type+'"]').addClass('filtered');
      });
    });
  }
  tabs = () => {
    $('body').on('click', '.buttons-line-id>a', function(e) {
      e.preventDefault();
      $('.cp-tabs-id > .tab').removeClass('open');
      var href = $(this).attr('href');
      $(href).addClass('open');
    });

    $('body').on('click', '.tabs>.tab>a.nav', function(e) {
      e.preventDefault();
      var tabsWrapper = $(this).parents('.tabs');
      if($(this).parent().hasClass('open')) {
        tabsWrapper.find('.tab').removeClass('open');
      }else{
        tabsWrapper.find('.tab').removeClass('open');
        $(this).parent().addClass('open ');
      }
    });
  }
  calendar = () => {
    $('body').on('click','.button.close', function(e) {
      e.preventDefault();
      $('#calendar_list').removeClass('open');
    });
    var $this = this;
    if($("#calendar").length > 0) {
      var next = $("#calendar").data('next');
      var prev = $("#calendar").data('prev');
      var clndrTemplate =
      "<div class='clndr-controls'>" +
          "<div class='clndr-control-button'>" +
              "<span class='clndr-previous-button'>"+prev+"</span>" +
          '</div>' +
          "<div class='month'><%= month %> <%= year %></div>" +
          "<div class='clndr-control-button rightalign'>" +
              "<span class='clndr-next-button'>"+next+"</span>" +
          '</div>' +
      '</div>' +
      "<table class='clndr-table' border='0' cellspacing='0' cellpadding='0'>" +
          '<thead>' +
              "<tr class='header-days'>" +
              '<% for(var i = 0; i < daysOfTheWeek.length; i++) { %>' +
                  "<td class='header-day'><%= daysOfTheWeek[i] %></td>" +
              '<% } %>' +
              '</tr>' +
          '</thead>' +
          '<tbody>' +
          '<% for(var i = 0; i < numberOfRows; i++){ %>' +
              '<tr>' +
              '<% for(var j = 0; j < 7; j++){ %>' +
              '<% var d = j + i * 7; %>' +
                  "<td class='<%= days[d].classes %>'>" +
                      "<div class='day-contents'><%= days[d].day %></div>" +
                  '</td>' +
              '<% } %>' +
              '</tr>' +
          '<% } %>' +
          '</tbody>' +
      '</table>';
      moment.locale($("#calendar").data('lang'));
      var theCalendarInstance = $('#calendar').clndr({
        daysOfTheWeek: ['Pr', 'A', 'T', 'K', 'Pn', 'Š', 'S'],
        template: clndrTemplate,
        clickEvents: {
          click: function(target) {
            if(target.events.length>0) {
              var title_string = $('#calendar').data('title');
              var price_string = $('#calendar').data('price');
              var close_string = $('#calendar').data('close');
              var confirm_string = $('#calendar').data('confirm');
              var isadmin = $('#calendar').data('isadmin');
              var price = $('#calendar').data('ac-price');
              $this.calendar_list(target.events,price,title_string,price_string,close_string,confirm_string,isadmin);
            }
          }
        }
      });

      var itmes = $('#calendar').data('events');
      theCalendarInstance.addEvents(itmes);
    }
  }
  copyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'sėkmingai' : 'nesėkmingai';
      alert('Nukopijuota ' + msg);
    } catch (err) {
      alert('Nepavyko nukopijuoti.');
    }

    document.body.removeChild(textArea);
  }
  countDown = () => {
    setInterval(function(){
      var reload = false;
      $('.count-down').each(function() {
        var number = parseInt($(this).data('time'));
        //console.log(number);
        if(number-1>0){
          var date = new Date(0);
          date.setSeconds(number-1);
          var timeString = date.toISOString().substr(11, 8);
          $(this).html(timeString);
          $(this).data('time', number-1);
        }else{
          reload = true;
        }
      });
      if(reload) {
        location.reload();
      }
    }, 1000);

  }
  init = () => {
    var obj = this;
    $('.datepicker').pickadate({
      selectMonths: true,
      selectYears: 200
    });

    //max: new Date(2012,11,31),
    this.tabs();
    this.calendar();
    this.formPoster();
    this.egzamFilter();
    this.tableFilter();
    this.regulartabs();
    this.countDown();
    //this.swiperInit();


    $('body').on('click', '.easycopy', function(e) {
      e.preventDefault();
      obj.copyTextToClipboard($(this).html());
    });

    $('.tooltip').tooltipster({
        theme: 'tooltipster-light'
    });


    $(window).on( "resize", function(e) {

    });
    $(window).on( "scroll", function(e) {

    });
  }
}
